import {Skeleton} from '@mui/material'
import React from 'react'

export const ForecastStatusSkeleton = () => {
  return <Skeleton variant="rounded" width={220} height={38} />
}
